import { useCallback, useEffect, useState } from "react";
import copyText from "@/core/helpers/copyText";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { setMessageIsCopied } from "@/domains/chat/slice";

export default () => {
  const dispatch = useAppDispatch();
  const [copiedValue, setCopiedValue] = useState<null | string>(null);

  useEffect(() => {
    if (copiedValue) {
      dispatch(setMessageIsCopied(true));
      const timeoutId = setTimeout(() => {
        dispatch(setMessageIsCopied(false));
        setCopiedValue(null);
      }, 1000);

      return () => {
        clearTimeout(timeoutId);
      };
    }

    return () => {};
  }, [copiedValue, dispatch]);

  const copyMessageHandler = useCallback((value: string) => {
    setCopiedValue(value);
    copyText(value);
  }, []);

  return { copyMessageHandler };
};
